import { action, asyncAction } from 'now-frontend-shared/utils/actions';

// async actions
export const getAllStates = asyncAction('states/GET_ALL_STATES');

// sync actions
export const clearState = action('states/CLEAR_STATE');
